"use strict";
exports.__esModule = true;
exports.SvgEmoji = void 0;
var tslib_1 = require("tslib");
/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
var react_1 = tslib_1.__importDefault(require("react"));
exports.SvgEmoji = function (props) { return (react_1["default"].createElement("svg", tslib_1.__assign({ viewBox: "0 0 24 24", fill: "none" }, props),
    react_1["default"].createElement("circle", { cx: 12, cy: 12, r: 9.25, stroke: "currentColor", strokeWidth: 1.5 }),
    react_1["default"].createElement("circle", { cx: 8.5, cy: 9.5, r: 1.5, fill: "currentColor" }),
    react_1["default"].createElement("circle", { cx: 15.5, cy: 9.5, r: 1.5, fill: "currentColor" }),
    react_1["default"].createElement("path", { d: "M16 14a4.04 4.04 0 01-1.436 2.119c-.701.54-1.562.847-2.458.878a4.293 4.293 0 01-2.516-.705A4.067 4.067 0 018 14.278", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }))); };
//# sourceMappingURL=Emoji.js.map